import { render } from "./CategoryComponent.vue?vue&type=template&id=43ac8a9c&scoped=true"
import script from "./CategoryComponent.vue?vue&type=script&lang=js"
export * from "./CategoryComponent.vue?vue&type=script&lang=js"

import "./CategoryComponent.vue?vue&type=style&index=0&id=43ac8a9c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ac8a9c"]])

export default __exports__